module.exports = __webpack_public_path__ + "static/img/report-icon.539fe59c.png";